<template>
    <div>
        <div>
            <div class="xcard">
                <p class="text-primary"> <span class="glyphicon glyphicon-star"></span> <b>Programas de Interes para este contacto:</b> </p> 
                <p class="text-inf"> <small> <b>INFO</b> Seleccione entre uno a dos programas de interes, <b>NOTA:</b> En caso de no existir el programa deseado, contactese con la parte academica para que registre el postgrado deseado.</small> </p>
                    <label class="typo__label" for="ajax">Buscar Programa:</label>
                    <p style="margin-bottom:0"> <small class="text-primary">* No incluya las palabras diplomado, maestria o especialidad en la busqueda.</small> </p>
                    <p v-if="isLoading" class="text-primary"> <small>Buscando...</small> </p>
                    <multiselect class="form-control" v-model="modelo.intereses" id="idpostgrado" label="nombre" track-by="idpostgrado" 
                    placeholder="Nombre del programa (4 letras minimo)..." 
                        open-direction="bottom" :options="datos" :multiple="multiple" 
                        :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" 
                        :close-on-select="true" 
                        :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600" 
                        :show-no-results="true" 
                        :hide-selected="false" :show-labels="false" @search-change="asyncFind">

                        <template slot="tag" slot-scope="{ option, remove }">
                        <p class="custom__tag">
                            <span>{{ parseLabel(option) }}</span>
                            <span class="custom__remove" @click="remove(option)">❌</span>
                        </p>
                        </template>
                        <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="modelo.intereses==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
                        </template>
                        <span slot="noResult">No se han encontrado resultados</span>
                    </multiselect>

            </div>
        </div>
        
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,multiple:{type:Boolean,default:false},default:{type:Array,required:false,default:null} },
    data () {
        return {
            isLoading: false,
            datos: [],
            modelo: {
                intereses: null,
            }
        }
    },
    watch:{
        'modelo.intereses': function(){
            this.model.intereses=this.modelo.intereses; 
        },
        'default':function(a){
            if( a == null ) return;
            this.modelo.intereses = a;
        },
    },
    methods: {
        parseLabel( option ){
            if( option == null ) return "";
            var cat = "";
            if( option.categoria ) cat = option.categoria.nombre;
            return cat+" - "+option.nombre;
        },
        parseLabel2( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg+" - "+option.num_doc;
        },
        limitText (count) {
            return `and ${count} other countries`
        },
        async asyncFind (query) {
            if( query ){
                query = query.trim();
                query = query.replace(/\s+/g, " ");
            }
            if( query.length <= 3 ) return;
            this.isLoading = true
            var vue = this;
            var sql = gql`query{ getPostgrados(nombre:"${query}"){id,nombre,categoria{nombre}} }`;
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
                vue.datos = [];
                vue.isLoading = false;
                var datas = [];
                if( vue.modelo.intereses ){
                    vue.modelo.intereses.forEach( function(e){
                        datas.push( {idpostgrado:e.idpostgrado,nombre:e.nombre} );
                    });
                }
                data.data.getPostgrados.forEach( function(e){
                  var cat = "";
                  if( e.categoria ) cat = e.categoria.nombre;
                  datas.push( {idpostgrado:e.id,nombre:cat+" - "+e.nombre} )
                })

                vue.datos = datas;
                //window.console.log( data.data,window.stringifyObject(vue.datos) )

            }).catch((error) => {
                window.console.error(error)
                vue.isLoading = false
                this.$notify( parseJsonError( error,'getPostgrados' ) )
            })
        },
        clearAll () {
            this.modelo.intereses = null;
        },
    },
    mounted(){
        
    }
}
</script>